import React, { useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import Dialog from "@mui/material/Dialog";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faXmark } from '@fortawesome/free-solid-svg-icons';
import { logout } from "../../controllers/accounts/Account";

const LogoutConformationPopup = ({ popUpOpen, togglePopUp }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = () => togglePopUp();

  const handleConfirm = async () => {
    setIsLoading(true);
    const res = await logout();
    if (res.status === true) {
      navigate(`${process.env.REACT_APP_LOGIN_URL || '/'}`);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      navigate(`${process.env.REACT_APP_LOGIN_URL || '/'}`);
    }
    setIsLoading(false);
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={togglePopUp}
      maxWidth="xs"
      fullWidth
      PaperProps={{ style: { borderRadius: '20px', overflow: 'hidden' } }}
    >
      <div style={styles.container}>
        {/* Close button */}
        <button style={styles.closeBtn} onClick={handleCancel} aria-label="Close">
          <FontAwesomeIcon icon={faXmark} />
        </button>

        {/* Icon */}
        <div style={styles.iconWrap}>
          <FontAwesomeIcon icon={faRightFromBracket} style={styles.icon} />
        </div>

        {/* Text */}
        <h2 style={styles.title}>Sign Out</h2>
        <p style={styles.subtitle}>
          Are you sure you want to log out of your account?
        </p>

        {/* Actions */}
        <div style={styles.actions}>
          <button style={styles.cancelBtn} onClick={handleCancel} disabled={isLoading}>
            Cancel
          </button>
          <button style={styles.confirmBtn} onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? (
              <span style={styles.spinner} />
            ) : (
              <>
                <FontAwesomeIcon icon={faRightFromBracket} />
                Sign Out
              </>
            )}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

const styles = {
  container: {
    padding: '36px 32px 28px',
    textAlign: 'center',
    fontFamily: "'Jost', sans-serif",
    position: 'relative',
  },
  closeBtn: {
    position: 'absolute',
    top: '14px',
    right: '16px',
    background: '#f5f5f5',
    border: 'none',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#888',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.15s',
  },
  iconWrap: {
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    background: '#fef2f2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  icon: {
    fontSize: '30px',
    color: '#ef4444',
  },
  title: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 8px',
    fontFamily: "'Jost', sans-serif",
  },
  subtitle: {
    fontSize: '14px',
    color: '#9ca3af',
    margin: '0 0 28px',
    lineHeight: '1.5',
    fontFamily: "'Jost', sans-serif",
  },
  actions: {
    display: 'flex',
    gap: '12px',
  },
  cancelBtn: {
    flex: 1,
    padding: '12px',
    border: '1.5px solid #e5e7eb',
    borderRadius: '10px',
    background: '#fff',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    cursor: 'pointer',
    fontFamily: "'Jost', sans-serif",
    transition: 'background 0.15s',
  },
  confirmBtn: {
    flex: 1,
    padding: '12px',
    border: 'none',
    borderRadius: '10px',
    background: '#ef4444',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: "'Jost', sans-serif",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'background 0.15s',
  },
  spinner: {
    display: 'inline-block',
    width: '16px',
    height: '16px',
    border: '2px solid rgba(255,255,255,0.35)',
    borderTopColor: '#fff',
    borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};

export default LogoutConformationPopup;
